export enum ManipulationState {
    None = 0,
    Copy = 1,
    Cut = 2
}
